import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import "./TermsConditions.css"; // same CSS as Terms & Conditions

const PrivacyPolicy = () => {
  return (
    <React.Fragment>
      <Header />
      <div className="privacy-policy">
        <Helmet>
          <title>Privacy Policy - Happy Pay Fintech</title>
          <meta
            name="description"
            content="Privacy Policy of Happy Pay Fintech. Learn how we collect, use, and protect your personal information when you use our AEPS, DMT, CMS, PAN card, and bill payment services."
          />
        </Helmet>

        <div className="body-overlay"></div>

        <main>
          {/* ===== Hero / Breadcrumb ===== */}
          <section className="contact-bg pb-130 pt-195">
            <div className="container">
              <div className="row">
                <div className="col-xxl-12">
                  <div className="breadcrumb__content p-relative z-index-1">
                    <h3 className="contact-title">Privacy Policy</h3>
                    <div className="breadcrumb__list">
                      <span>
                        <a href="/">Home</a>
                      </span>
                      <span className="dvdr"></span>
                      <span>Privacy Policy</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* ===== Privacy Policy Content inside a Card (same class as Terms) ===== */}
          <div className="container py-5">
            <div className="terms-card p-5 bg-white rounded shadow-sm">
              <h1 className="fw-bold text-center mb-4">Privacy Policy</h1>
              <p className="text-center text-muted effective-date">
                Last Updated: 18.02.2026
              </p>

              <section className="mb-5">
                <h2>1. Introduction</h2>
                <p>
                  AYYAAND PAY FINTECH PRIVATE LIMITED ("we", "us", "our", or
                  "Happy Pay Fintech") is committed to protecting your privacy.
                  This Privacy Policy explains how we collect, use, disclose,
                  and safeguard your information when you use our website,
                  mobile application, and services, including but not limited to
                  AEPS, DMT, CMS, PAN card services, and utility bill payments.
                  Please read this policy carefully. By accessing or using our
                  services, you consent to the practices described in this
                  Privacy Policy.
                </p>
                <p>
                  Our registered office is located at: <br />
                  <strong>AYYAAND PAY FINTECH PRIVATE LIMITED</strong>
                  <br />
                  C/o Sri B.channayya, Ter Bazar Main Road Kanakgiri, Near
                  Partana Panchayat, Kanakgiri, Koppal, Karnataka - 583283
                </p>
              </section>

              <section className="mb-5">
                <h2>2. Information We Collect</h2>
                <p>We may collect the following types of information:</p>
                <ul>
                  <li>
                    <strong>Personal Identification Information:</strong> Name,
                    date of birth, gender, address, email address, phone number,
                    and photograph.
                  </li>
                  <li>
                    <strong>Financial Information:</strong> Bank account
                    details, Aadhaar number (for AEPS services), PAN card
                    details, transaction history, and payment instrument
                    details.
                  </li>
                  <li>
                    <strong>Technical Information:</strong> IP address, browser
                    type, device information, operating system, and usage data
                    (pages visited, time spent, etc.).
                  </li>
                  <li>
                    <strong>KYC Documents:</strong> Copies of identification
                    documents (Aadhaar, PAN, etc.) provided for verification
                    purposes.
                  </li>
                  <li>
                    <strong>Location Information:</strong> With your consent, we
                    may collect your precise location to prevent fraud and
                    ensure compliance.
                  </li>
                </ul>
              </section>

              <section className="mb-5">
                <h2>3. How We Collect Information</h2>
                <p>We collect information through:</p>
                <ul>
                  <li>Registration and account creation forms.</li>
                  <li>Transaction forms when you use our services.</li>
                  <li>KYC submission processes.</li>
                  <li>Cookies and similar tracking technologies.</li>
                  <li>Customer support interactions.</li>
                  <li>
                    Third‑party sources, such as banks or payment gateways, with
                    your consent.
                  </li>
                </ul>
              </section>

              <section className="mb-5">
                <h2>4. Use of Your Information</h2>
                <p>
                  We use the collected information for the following purposes:
                </p>
                <ul>
                  <li>
                    To provide, maintain, and improve our services (AEPS, DMT,
                    CMS, PAN, bill payments).
                  </li>
                  <li>
                    To process transactions and send transaction confirmations.
                  </li>
                  <li>
                    To verify your identity and comply with KYC/AML regulations.
                  </li>
                  <li>
                    To communicate with you about your account, updates, and
                    promotional offers (with opt‑out option).
                  </li>
                  <li>
                    To detect, prevent, and address fraud, security breaches, or
                    technical issues.
                  </li>
                  <li>
                    To comply with legal obligations and enforce our Terms &
                    Conditions.
                  </li>
                  <li>To analyze usage trends and improve user experience.</li>
                </ul>
              </section>

              <section className="mb-5">
                <h2>5. Sharing of Information</h2>
                <p>We may share your information with:</p>
                <ul>
                  <li>
                    <strong>Service Providers:</strong> Third‑party vendors who
                    assist us in operating our platform, processing payments,
                    conducting KYC, or providing customer support. These parties
                    are bound by confidentiality agreements.
                  </li>
                  <li>
                    <strong>Financial Institutions and Partners:</strong> Banks,
                    payment aggregators, and utility companies necessary to
                    execute your transactions.
                  </li>
                  <li>
                    <strong>Regulatory Authorities:</strong> Government bodies
                    or law enforcement agencies when required by law or to
                    protect our rights.
                  </li>
                  <li>
                    <strong>Business Transfers:</strong> In the event of a
                    merger, acquisition, or asset sale, your information may be
                    transferred to the successor entity.
                  </li>
                </ul>
                <p>
                  We do not sell, rent, or trade your personal information to
                  third parties for marketing purposes.
                </p>
              </section>

              <section className="mb-5">
                <h2>6. Data Security</h2>
                <p>
                  We implement appropriate technical and organizational measures
                  to protect your personal data against unauthorized access,
                  alteration, disclosure, or destruction. These measures include
                  encryption, firewalls, secure servers, and access controls.
                  However, no method of transmission over the Internet or
                  electronic storage is 100% secure, and we cannot guarantee
                  absolute security.
                </p>
              </section>

              <section className="mb-5">
                <h2>7. Retention of Data</h2>
                <p>
                  We retain your personal information for as long as necessary
                  to fulfill the purposes outlined in this Privacy Policy,
                  unless a longer retention period is required or permitted by
                  law (e.g., for regulatory, tax, or legal reasons). KYC
                  documents and transaction records are retained as per
                  applicable laws.
                </p>
              </section>

              <section className="mb-5">
                <h2>8. Your Rights</h2>
                <p>You have the right to:</p>
                <ul>
                  <li>
                    Access and obtain a copy of your personal data held by us.
                  </li>
                  <li>Request correction of inaccurate or incomplete data.</li>
                  <li>
                    Request deletion of your data, subject to legal obligations.
                  </li>
                  <li>
                    Withdraw consent at any time, where processing is based on
                    consent.
                  </li>
                  <li>
                    Lodge a complaint with a supervisory authority (e.g., Data
                    Protection Authority).
                  </li>
                </ul>
                <p>
                  To exercise these rights, please contact us at the details
                  provided in Section 13.
                </p>
              </section>

              <section className="mb-5">
                <h2>9. Cookies and Tracking Technologies</h2>
                <p>
                  We use cookies and similar technologies to enhance your
                  experience, analyze site traffic, and personalize content. You
                  can set your browser to refuse cookies, but some features of
                  our platform may not function properly. For more details, see
                  our <Link to="/cookie-policy">Cookie Policy</Link>.
                </p>
              </section>

              <section className="mb-5">
                <h2>10. Third‑Party Links</h2>
                <p>
                  Our platform may contain links to third‑party websites or
                  services. We are not responsible for the privacy practices or
                  content of those third parties. We encourage you to read their
                  privacy policies before providing any information.
                </p>
              </section>

              <section className="mb-5">
                <h2>11. Children's Privacy</h2>
                <p>
                  Our services are not intended for individuals under the age of
                  18. We do not knowingly collect personal information from
                  minors. If you become aware that a minor has provided us with
                  personal data, please contact us, and we will take steps to
                  delete such information.
                </p>
              </section>

              <section className="mb-5">
                <h2>12. Changes to This Privacy Policy</h2>
                <p>
                  We may update this Privacy Policy from time to time. Any
                  changes will be posted on this page with an updated "Last
                  Updated" date. We encourage you to review this policy
                  periodically. Your continued use of our services after any
                  modifications indicates your acceptance of the revised policy.
                </p>
              </section>

              <section className="mb-5">
                <h2>13. Contact Us</h2>
                <p>
                  If you have any questions, concerns, or requests regarding
                  this Privacy Policy or our data practices, you may contact us
                  at:
                </p>
                <address>
                  <strong>AYYAAND PAY FINTECH PRIVATE LIMITED</strong>
                  <br />
                  C/o Sri B.channayya, Ter Bazar Main Road Kanakgiri, Near
                  Partana Panchayat, Kanakgiri, Koppal
                  <br />
                  Karnataka - 583283, India
                  <br />
                  Phone: +91 9741314333
                  <br />
                  Email: happypayfintech@gmail.com
                </address>
              </section>

              <div className="text-center mt-5">
                <p className="mt-3 text-muted">
                  By using our services, you acknowledge that you have read and
                  understood this Privacy Policy.
                </p>
              </div>
            </div>
          </div>
        </main>
      </div>
      <Footer />
    </React.Fragment>
  );
};

export default PrivacyPolicy;
